import { render, staticRenderFns } from "./HeaderLogin.vue?vue&type=template&id=16a742b0&scoped=true"
var script = {}
import style0 from "./HeaderLogin.vue?vue&type=style&index=0&id=16a742b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a742b0",
  null
  
)

export default component.exports